import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    height: '100%',
    gap: '20px',
    padding: '24px',
    minHeight: 0,
  },
  sections: {
    display: 'flex',
    flex: 4,
    flexDirection: 'column',
    gap: '20px',
    overflow: 'scroll',
  },
};
